import Portal from "../../components/Portal"
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {doLogout} from "../Auth/operations";
import {
    doGetCOReportInformation,
    doGetDAYNNIGHTTotalRevenue,
    doGetIAVENTURESLLCTotalRevenue,
    doGetOKReportInformation,
    doGetRevenue,
    doGetRevenueFilter,
    doGetSHAHVENTURESLLCTotalRevenue,
    doGetSOLOVENTURESCOTotalRevenue,
    doGetSZXVENTURESLLCTotalRevenue,
    doGetUNOVENTURESCOTotalRevenue,
    doGetUTReportInformation,
    doGetVIBEZVENTURESLLCTotalRevenue,
    doGetVRLVENTURESLLCTotalRevenue,
    doGetSCDLVENTURESLLCTotalRevenue,
    doGetTMPEVENTURESLLCTotalRevenue,
    doGetFRDKVENTURESLLCTotalRevenue,
    doGetCHDLVENTURESLLCTotalRevenue,
    doGetTHRNVENTURESLLCTotalRevenue
} from "../Revenue/operations";

const PortalContainer = props => {
    const {
        user, token, doLogout, history,
        daynnightRevenue,
        shahventuresllcRevenue,
        unoventurescoRevenue,
        soloventurescoRevenue,
        vibezventuresllcRevenue,
        iaventuresllcRevenue,
        szxventuresllcRevenue,
        vrlventuresllcRevenue,
        scdlventuresllcRevenue,
        tmpeventuresllcRevenue,
        frdkventuresllcRevenue,
        chdlventuresllcRevenue,
        thrnventuresllcRevenue,
        odooUtahRevenue,
        odooColoradoRevenue,
        odooOklahomaRevenue,
        revenue,
        revenueFilter,
        doGetDAYNNIGHTTotalRevenue,
        doGetSHAHVENTURESLLCTotalRevenue,
        doGetUNOVENTURESCOTotalRevenue,
        doGetSOLOVENTURESCOTotalRevenue,
        doGetVIBEZVENTURESLLCTotalRevenue,
        doGetIAVENTRUESLLCTotalRevenue,
        doGetSZXVENTURESLLCTotalRevenue,
        doGetVRLVENTURESLLCTotalRevenue,
        doGetSCDLVENTURESLLCTotalRevenue,
        doGetTMPEVENTURESLLCTotalRevenue,
        doGetFRDKVENTURESLLCTotalRevenue,
        doGetCHDLVENTURESLLCTotalRevenue,
        doGetTHRNVENTURESLLCTotalRevenue,
        doGetUTReportInformation,
        doGetCOReportInformation,
        doGetOKReportInformation,
        doGetRevenue,
        doGetRevenueFilter
    } = props;
    return <Portal
        user={user}
        token={token}
        history={history}
        doLogout={doLogout}
        daynnightRevenue={daynnightRevenue}
        shahventuresllcRevenue={shahventuresllcRevenue}
        unoventurescoRevenue={unoventurescoRevenue}
        soloventurescoRevenue={soloventurescoRevenue}
        vibezventuresllcRevenue={vibezventuresllcRevenue}
        iaventuresllcRevenue={iaventuresllcRevenue}
        szxventuresllcRevenue={szxventuresllcRevenue}
        vrlventuresllcRevenue={vrlventuresllcRevenue}
        scdlventuresllcRevenue={scdlventuresllcRevenue}
        tmpeventuresllcRevenue={tmpeventuresllcRevenue}
        frdkventuresllcRevenue={frdkventuresllcRevenue}
        chdlventuresllcRevenue={chdlventuresllcRevenue}
        thrnventuresllcRevenue={thrnventuresllcRevenue}
        odooUtahRevenue={odooUtahRevenue}
        odooColoradoRevenue={odooColoradoRevenue}
        odooOklahomaRevenue={odooOklahomaRevenue}
        revenue={revenue}
        revenueFilter={revenueFilter}
        doGetDAYNNIGHTTotalRevenue={doGetDAYNNIGHTTotalRevenue}
        doGetSHAHVENTURESLLCTotalRevenue={doGetSHAHVENTURESLLCTotalRevenue}
        doGetUNOVENTURESCOTotalRevenue={doGetUNOVENTURESCOTotalRevenue}
        doGetSOLOVENTURESCOTotalRevenue={doGetSOLOVENTURESCOTotalRevenue}
        doGetVIBEZVENTURESLLCTotalRevenue={doGetVIBEZVENTURESLLCTotalRevenue}
        doGetIAVENTRUESLLCTotalRevenue={doGetIAVENTRUESLLCTotalRevenue}
        doGetSZXVENTURESLLCTotalRevenue={doGetSZXVENTURESLLCTotalRevenue}
        doGetVRLVENTURESLLCTotalRevenue={doGetVRLVENTURESLLCTotalRevenue}
        doGetSCDLVENTURESLLCTotalRevenue={doGetSCDLVENTURESLLCTotalRevenue}
        doGetTMPEVENTURESLLCTotalRevenue={doGetTMPEVENTURESLLCTotalRevenue}
        doGetFRDKVENTURESLLCTotalRevenue={doGetFRDKVENTURESLLCTotalRevenue}
        doGetCHDLVENTURESLLCTotalRevenue={doGetCHDLVENTURESLLCTotalRevenue}
        doGetTHRNVENTURESLLCTotalRevenue={doGetTHRNVENTURESLLCTotalRevenue}
        doGetUTReportInformation={doGetUTReportInformation}
        doGetCOReportInformation={doGetCOReportInformation}
        doGetOKReportInformatio={doGetOKReportInformation}
        doGetRevenue={doGetRevenue}
        doGetRevenueFilter={doGetRevenueFilter}
    />;
}

const mapStateToProps = state => ({
    user: state.authReducer.user,
    token: state.authReducer.token,
    daynnightRevenue: state.revenueReducer.daynnightRevenue,
    shahventuresllcRevenue: state.revenueReducer.shahventuresllcRevenue,
    unoventurescoRevenue: state.revenueReducer.unoventurescoRevenue,
    soloventurescoRevenue: state.revenueReducer.soloventurescoRevenue,
    vibezventuresllcRevenue: state.revenueReducer.vibezventuresllcRevenue,
    iaventuresllcRevenue: state.revenueReducer.iaventuresllcRevenue,
    szxventuresllcRevenue: state.revenueReducer.szxventuresllcRevenue,
    vrlventuresllcRevenue: state.revenueReducer.vrlventuresllcRevenue,
    scdlventuresllcRevenue: state.revenueReducer.scdlventuresllcRevenue,
    tmpeventuresllcRevenue: state.revenueReducer.tmpeventuresllcRevenue,
    frdkventuresllcRevenue: state.revenueReducer.frdkventuresllcRevenue,
    chdlventuresllcRevenue: state.revenueReducer.chdlventuresllcRevenue,
    thrnventuresllcRevenue: state.revenueReducer.thrnventuresllcRevenue,
    odooUtahRevenue: state.revenueReducer.odooUtahRevenue,
    odooColoradoRevenue: state.revenueReducer.odooColoradoRevenue,
    odooOklahomaRevenue: state.revenueReducer.odooOklahomaRevenue,

    revenue: state.revenueReducer.revenue,
    revenueFilter: state.revenueReducer.revenueFilter
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            doLogout,

            doGetDAYNNIGHTTotalRevenue,
            doGetSHAHVENTURESLLCTotalRevenue,
            doGetUNOVENTURESCOTotalRevenue,
            doGetSOLOVENTURESCOTotalRevenue,
            doGetVIBEZVENTURESLLCTotalRevenue,
            doGetIAVENTURESLLCTotalRevenue,
            doGetSZXVENTURESLLCTotalRevenue,
            doGetVRLVENTURESLLCTotalRevenue,
            doGetSCDLVENTURESLLCTotalRevenue,
            doGetTMPEVENTURESLLCTotalRevenue,
            doGetFRDKVENTURESLLCTotalRevenue,
            doGetCHDLVENTURESLLCTotalRevenue,
            doGetTHRNVENTURESLLCTotalRevenue,
            doGetUTReportInformation,
            doGetCOReportInformation,
            doGetOKReportInformation,
            doGetRevenue,
            doGetRevenueFilter
        },
        dispatch,
    );

PortalContainer.propTypes = {}
export default connect(mapStateToProps, mapDispatchToProps)(PortalContainer);
